module.exports = __webpack_public_path__ + "img/img (25).ab1d0083.jpg";